const numberFormatter = new Intl.NumberFormat("en-US");
const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});
const percentFormatter = new Intl.NumberFormat("en-US", {
  style: "percent",
  maximumFractionDigits: 1,
});

export function formatNumber(value) {
  return numberFormatter.format(value);
}

export function formatCurrency(value) {
  return currencyFormatter.format(value);
}

export function formatPercent(value) {
  return percentFormatter.format(value);
}

export function formatDelta(value) {
  const sign = value > 0 ? "+" : "";
  return `${sign}${value}`;
}

export function formatDateRange(start, end) {
  return `${start} to ${end}`;
}

export function maskKey(value, visibleSuffix = 4) {
  const suffix = value.slice(-visibleSuffix);
  return `${"•".repeat(Math.max(0, value.length - visibleSuffix))}${suffix}`;
}
